import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

export function useGoogleAuthentication(loginToBackend: (token: string) => void) : readonly[() => void] {
    
    const login = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: (resp) => axios.post('https://oauth2.googleapis.com/token', {
            code: resp?.code,
            client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
            client_secret: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_SECRET,
            redirect_uri: "postmessage",
            grant_type: "authorization_code"
        }).then(response => loginToBackend(response?.data?.id_token)),
        onError: () => {}
    });

    return [login] as const;
}